export const apiPath = '/v1/audits';
const actionType = 'AUDIT';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
